var imageReadyResolver = function imageReadyResolver(image, cb) {
  if (image.complete && image.naturalHeight !== 0) {
    cb();
  } else {
    // eslint-disable-next-line no-param-reassign
    image.onload = function () {
      cb();
    };
  }
};

export { imageReadyResolver as default };
